// AUTO-GENERATED from model/omnea.fga by `pnpm generate:authz`. Do not edit.

/** Every object type declared in the authorization model. */
export const FGA_OBJECT_TYPES = [
  'user',
  'group',
  'role',
  'pool',
  'organisation',
  'config_area',
  'sensitive_data',
  'scope_dimension',
  'scope_value',
  'supplier',
  'supplier_grant',
  'supplier_permission_set',
  'supplier_participant_grant',
  'request',
  'request_grant',
  'request_permission_set',
  'agreement',
  'renewal',
  'risk',
  'agreement_grant',
  'agreement_permission_set',
  'document',
  'document_grant',
  'tprm_grant',
  'bill',
  'bill_grant',
  'bill_permission_set',
  'workflow',
  'workflow_grant',
  'workflow_permission_set',
  'insights_dashboard',
] as const

/** An object type declared in the authorization model. */
export type FgaObjectType = (typeof FGA_OBJECT_TYPES)[number]

/** Every relation defined on each object type. */
export const FGA_RELATIONS = {
  user: [],
  group: ['derived_member'],
  role: ['derived_assignee', 'assignee'],
  pool: ['derived_member'],
  organisation: [
    'derived_owner',
    'derived_admin',
    'derived_viewer',
    'derived_user',
    'derived_member',
    'system_admin',
    'permission_admin',
    'can_manage_permissions',
    'custom_field_admin',
    'can_manage_custom_fields',
    'insights_access',
    'can_view_insights',
    'can_manage_insights',
    'can_manage_budgets',
    'document_grant',
    'can_manage_all_documents',
    'can_edit_all_documents',
    'can_view_all_documents',
    'conf_can_manage_all_documents',
    'conf_can_edit_all_documents',
    'conf_can_view_all_documents',
    'subprocessor_grant',
    'can_manage_all_subprocessors',
    'can_edit_all_subprocessors',
    'can_view_all_subprocessors',
    'risk_grant',
    'can_manage_all_risks',
    'can_edit_all_risks',
    'can_view_all_risks',
    'conf_can_manage_all_risks',
    'conf_can_edit_all_risks',
    'conf_can_view_all_risks',
    'alert_grant',
    'can_edit_all_alerts',
    'can_view_all_alerts',
    'conf_can_edit_all_alerts',
    'conf_can_view_all_alerts',
    'supplier_grant',
    'request_grant',
    'agreement_grant',
    'bill_grant',
    'can_view_all_suppliers',
    'can_edit_all_suppliers',
    'can_view_tprm_all_suppliers',
    'can_edit_tprm_all_suppliers',
    'can_manage_tprm_all_suppliers',
    'can_view_related_requests_all_suppliers',
    'can_view_related_agreements_all_suppliers',
    'can_view_related_documents_all_suppliers',
    'can_view_related_submissions_all_suppliers',
    'can_manage_documents_all_suppliers',
    'can_edit_documents_all_suppliers',
    'can_manage_internal_contacts_all_suppliers',
    'can_manage_external_contacts_all_suppliers',
    'can_manage_products_all_suppliers',
    'can_create_product_all_suppliers',
    'can_add_agreement_all_suppliers',
    'can_administer_all_suppliers',
    'can_create_supplier',
    'can_view_all_requests',
    'can_view_tprm_all_requests',
    'can_edit_tprm_all_requests',
    'can_manage_tprm_all_requests',
    'can_edit_metadata_all_requests',
    'can_manage_participants_all_requests',
    'can_pause_all_requests',
    'can_reject_all_requests',
    'can_delete_all_requests',
    'can_edit_submissions_all_requests',
    'can_manage_documents_all_requests',
    'can_view_documents_all_requests',
    'can_edit_documents_all_requests',
    'can_manage_assignees_all_requests',
    'can_skip_all_requests',
    'can_rollback_all_requests',
    'can_manage_integrations_all_requests',
    'can_manage_sourcing_all_requests',
    'can_administer_all_requests',
    'request_creator',
    'can_create_request',
    'confidential_request_access',
    'confidential_supplier_access',
    'confidential_agreement_access',
    'confidential_document_access',
    'conf_can_view_all_requests',
    'conf_can_view_tprm_all_requests',
    'conf_can_edit_tprm_all_requests',
    'conf_can_manage_tprm_all_requests',
    'conf_can_edit_metadata_all_requests',
    'conf_can_manage_participants_all_requests',
    'conf_can_pause_all_requests',
    'conf_can_reject_all_requests',
    'conf_can_delete_all_requests',
    'conf_can_edit_submissions_all_requests',
    'conf_can_manage_documents_all_requests',
    'conf_can_view_documents_all_requests',
    'conf_can_edit_documents_all_requests',
    'conf_can_manage_assignees_all_requests',
    'conf_can_skip_all_requests',
    'conf_can_rollback_all_requests',
    'conf_can_manage_integrations_all_requests',
    'conf_can_manage_sourcing_all_requests',
    'conf_can_administer_all_requests',
    'conf_can_view_all_suppliers',
    'conf_can_edit_all_suppliers',
    'conf_can_view_tprm_all_suppliers',
    'conf_can_edit_tprm_all_suppliers',
    'conf_can_manage_tprm_all_suppliers',
    'conf_can_view_related_requests_all_suppliers',
    'conf_can_view_related_agreements_all_suppliers',
    'conf_can_view_related_documents_all_suppliers',
    'conf_can_view_related_submissions_all_suppliers',
    'conf_can_manage_documents_all_suppliers',
    'conf_can_edit_documents_all_suppliers',
    'conf_can_manage_internal_contacts_all_suppliers',
    'conf_can_manage_external_contacts_all_suppliers',
    'conf_can_manage_products_all_suppliers',
    'conf_can_create_product_all_suppliers',
    'conf_can_add_agreement_all_suppliers',
    'conf_can_administer_all_suppliers',
    'can_view_all_agreements',
    'can_edit_all_agreements',
    'can_view_related_supplier_all_agreements',
    'can_view_related_requests_all_agreements',
    'can_view_documents_all_agreements',
    'can_cancel_all_agreements',
    'can_manage_renewals_all_agreements',
    'can_manage_documents_all_agreements',
    'can_edit_documents_all_agreements',
    'can_delete_all_agreements',
    'can_administer_all_agreements',
    'can_view_all_bills',
    'can_edit_before_accept_all_bills',
    'can_accept_all_bills',
    'conf_can_view_all_agreements',
    'conf_can_edit_all_agreements',
    'conf_can_cancel_all_agreements',
    'conf_can_view_related_supplier_all_agreements',
    'conf_can_view_related_requests_all_agreements',
    'conf_can_manage_renewals_all_agreements',
    'conf_can_view_documents_all_agreements',
    'conf_can_manage_documents_all_agreements',
    'conf_can_edit_documents_all_agreements',
    'conf_can_delete_all_agreements',
    'conf_can_administer_all_agreements',
  ],
  config_area: ['structural_organisation', 'manager', 'viewer', 'can_manage', 'can_view'],
  sensitive_data: ['structural_organisation', 'viewer', 'can_view'],
  scope_dimension: [
    'structural_organisation',
    'confidential_request_access',
    'confidential_supplier_access',
    'confidential_agreement_access',
    'matching_supplier_grant',
    'matching_request_grant',
    'matching_agreement_grant',
    'matching_can_view_supplier',
    'matching_can_view_tprm',
    'matching_can_edit_tprm',
    'matching_can_manage_tprm',
    'matching_can_view_related_requests',
    'matching_can_view_related_agreements',
    'matching_can_view_related_documents',
    'matching_can_view_related_submissions',
    'matching_can_edit',
    'matching_can_manage_documents',
    'matching_can_edit_documents',
    'matching_can_manage_internal_contacts',
    'matching_can_manage_external_contacts',
    'matching_can_manage_products',
    'matching_can_create_product',
    'matching_can_add_agreement',
    'matching_can_administer',
    'matching_can_view_request',
    'matching_can_view_tprm_request',
    'matching_can_edit_tprm_request',
    'matching_can_manage_tprm_request',
    'matching_can_edit_metadata_request',
    'matching_can_manage_participants_request',
    'matching_can_pause_request',
    'matching_can_reject_request',
    'matching_can_delete_request',
    'matching_can_edit_submissions_request',
    'matching_can_manage_documents_request',
    'matching_can_view_documents_request',
    'matching_can_edit_documents_request',
    'matching_can_manage_assignees_request',
    'matching_can_skip_request',
    'matching_can_rollback_request',
    'matching_can_manage_integrations_request',
    'matching_can_manage_sourcing_request',
    'matching_can_administer_request',
    'matching_can_view_agreement',
    'matching_can_view_related_supplier_agreement',
    'matching_can_view_related_requests_agreement',
    'matching_can_view_documents_agreement',
    'matching_can_edit_agreement',
    'matching_can_cancel_agreement',
    'matching_can_manage_renewals_agreement',
    'matching_can_manage_documents_agreement',
    'matching_can_edit_documents_agreement',
    'matching_can_delete_agreement',
    'matching_can_administer_agreement',
  ],
  scope_value: [
    'structural_dimension',
    'derived_member',
    'confidential_request_access',
    'confidential_supplier_access',
    'confidential_agreement_access',
    'supplier_grant',
    'request_grant',
    'agreement_grant',
    'confers_view_supplier',
    'confers_view_tprm',
    'confers_edit_tprm',
    'confers_manage_tprm',
    'confers_view_related_requests',
    'confers_view_related_agreements',
    'confers_view_related_documents',
    'confers_view_related_submissions',
    'confers_edit',
    'confers_manage_documents',
    'confers_edit_documents',
    'confers_manage_internal_contacts',
    'confers_manage_external_contacts',
    'confers_manage_products',
    'confers_create_product',
    'confers_add_agreement',
    'confers_administer',
    'confers_view_request',
    'confers_view_tprm_request',
    'confers_edit_tprm_request',
    'confers_manage_tprm_request',
    'confers_edit_metadata_request',
    'confers_manage_participants_request',
    'confers_pause_request',
    'confers_reject_request',
    'confers_delete_request',
    'confers_edit_submissions_request',
    'confers_manage_documents_request',
    'confers_view_documents_request',
    'confers_edit_documents_request',
    'confers_manage_assignees_request',
    'confers_skip_request',
    'confers_rollback_request',
    'confers_manage_integrations_request',
    'confers_manage_sourcing_request',
    'confers_administer_request',
    'conf_confers_view_supplier',
    'conf_confers_edit',
    'conf_confers_view_tprm',
    'conf_confers_edit_tprm',
    'conf_confers_manage_tprm',
    'conf_confers_view_related_requests',
    'conf_confers_view_related_agreements',
    'conf_confers_view_related_documents',
    'conf_confers_view_related_submissions',
    'conf_confers_manage_documents',
    'conf_confers_edit_documents',
    'conf_confers_manage_internal_contacts',
    'conf_confers_manage_external_contacts',
    'conf_confers_manage_products',
    'conf_confers_create_product',
    'conf_confers_add_agreement',
    'conf_confers_administer',
    'conf_confers_view_request',
    'conf_confers_view_tprm_request',
    'conf_confers_edit_tprm_request',
    'conf_confers_manage_tprm_request',
    'conf_confers_edit_metadata_request',
    'conf_confers_manage_participants_request',
    'conf_confers_pause_request',
    'conf_confers_reject_request',
    'conf_confers_delete_request',
    'conf_confers_edit_submissions_request',
    'conf_confers_manage_documents_request',
    'conf_confers_view_documents_request',
    'conf_confers_edit_documents_request',
    'conf_confers_manage_assignees_request',
    'conf_confers_skip_request',
    'conf_confers_rollback_request',
    'conf_confers_manage_integrations_request',
    'conf_confers_manage_sourcing_request',
    'conf_confers_administer_request',
    'confers_view_agreement',
    'confers_view_related_supplier_agreement',
    'confers_view_related_requests_agreement',
    'confers_view_documents_agreement',
    'confers_edit_agreement',
    'confers_cancel_agreement',
    'confers_manage_renewals_agreement',
    'confers_manage_documents_agreement',
    'confers_edit_documents_agreement',
    'confers_delete_agreement',
    'confers_administer_agreement',
    'conf_confers_view_agreement',
    'conf_confers_edit_agreement',
    'conf_confers_cancel_agreement',
    'conf_confers_view_related_supplier_agreement',
    'conf_confers_view_related_requests_agreement',
    'conf_confers_manage_renewals_agreement',
    'conf_confers_view_documents_agreement',
    'conf_confers_manage_documents_agreement',
    'conf_confers_edit_documents_agreement',
    'conf_confers_delete_agreement',
    'conf_confers_administer_agreement',
  ],
  supplier: [
    'derived_organisation',
    'derived_scope',
    'derived_contact',
    'derived_participant_grant',
    'derived_organisation_confidential',
    'derived_scope_confidential',
    'derived_agreement',
    'derived_agreement_confidential',
    'viewer',
    'owner',
    'grant',
    'contact_view',
    'contact_view_tprm',
    'contact_edit_tprm',
    'contact_manage_tprm',
    'contact_view_related_requests',
    'contact_view_related_agreements',
    'contact_view_related_documents',
    'contact_view_related_submissions',
    'contact_edit',
    'contact_edit_documents',
    'contact_manage_documents',
    'contact_manage_internal_contacts',
    'contact_manage_external_contacts',
    'contact_manage_products',
    'contact_create_product',
    'contact_add_agreement',
    'contact_administer',
    'derived_parent',
    'derived_parent_confidential',
    'own_view',
    'lineage_view',
    'conf_lineage_view',
    'can_view',
    'own_explicit_view',
    'lineage_explicit_view',
    'conf_lineage_explicit_view',
    'explicit_view',
    'can_edit',
    'can_view_subprocessors',
    'can_edit_subprocessors',
    'can_manage_subprocessors',
    'can_view_risks',
    'can_edit_risks',
    'can_manage_risks',
    'can_view_alerts',
    'can_edit_alerts',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
    'can_view_related_requests',
    'can_view_related_agreements',
    'conf_can_view_related_requests',
    'conf_can_view_related_agreements',
    'explicit_can_view_related_requests',
    'explicit_can_view_related_agreements',
    'can_view_related_documents',
    'can_view_related_submissions',
    'can_manage_documents',
    'can_edit_documents',
    'explicit_can_view_related_documents',
    'explicit_can_manage_documents',
    'explicit_can_edit_documents',
    'can_manage_internal_contacts',
    'can_manage_external_contacts',
    'can_manage_products',
    'can_create_product',
    'can_add_agreement',
    'can_administer',
  ],
  supplier_grant: [
    'subject',
    'custom_set',
    'viewer_set',
    'owner_set',
    'can_view',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
    'can_view_related_requests',
    'can_view_related_agreements',
    'can_view_related_documents',
    'can_view_related_submissions',
    'can_edit',
    'can_manage_documents',
    'can_edit_documents',
    'can_manage_internal_contacts',
    'can_manage_external_contacts',
    'can_manage_products',
    'can_create_product',
    'can_add_agreement',
    'can_create',
    'can_administer',
  ],
  supplier_permission_set: [
    'structural_organisation',
    'grants_view',
    'grants_view_tprm',
    'grants_edit_tprm',
    'grants_manage_tprm',
    'grants_view_related_requests',
    'grants_view_related_agreements',
    'grants_view_related_documents',
    'grants_view_related_submissions',
    'grants_edit',
    'grants_manage_documents',
    'grants_edit_documents',
    'grants_manage_internal_contacts',
    'grants_manage_external_contacts',
    'grants_manage_products',
    'grants_create_product',
    'grants_add_agreement',
    'grants_administer',
    'grants_create',
    'grants_any',
  ],
  supplier_participant_grant: [
    'derived_member',
    'derived_participant_set',
    'can_view',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
    'can_view_related_requests',
    'can_view_related_agreements',
    'can_view_related_documents',
    'can_view_related_submissions',
    'can_edit',
    'can_edit_documents',
    'can_manage_documents',
    'can_manage_internal_contacts',
    'can_manage_external_contacts',
    'can_manage_products',
    'can_create_product',
    'can_add_agreement',
    'can_administer',
  ],
  request: [
    'derived_organisation',
    'derived_scope',
    'derived_organisation_confidential',
    'derived_scope_confidential',
    'derived_supplier',
    'derived_supplier_confidential',
    'derived_agreement',
    'derived_agreement_confidential',
    'derived_requester',
    'derived_collaborator',
    'derived_rfx_owner',
    'grant',
    'explicit_view',
    'can_view',
    'can_edit_metadata',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
    'can_view_risks',
    'can_edit_risks',
    'can_manage_risks',
    'can_edit_po_number',
    'can_manage_participants',
    'can_manage_followers',
    'can_pause',
    'can_manage_documents',
    'can_view_documents',
    'can_edit_documents',
    'explicit_can_manage_documents',
    'explicit_can_view_documents',
    'explicit_can_edit_documents',
    'can_manage_sourcing_granted',
    'can_manage_sourcing',
    'can_reject',
    'can_delete',
    'can_edit_submissions',
    'can_manage_assignees',
    'can_skip',
    'can_rollback',
    'can_manage_integrations',
    'can_administer',
  ],
  request_grant: [
    'subject',
    'custom_set',
    'viewer_set',
    'owner_set',
    'can_view',
    'can_edit_metadata',
    'can_manage_participants',
    'can_pause',
    'can_reject',
    'can_delete',
    'can_edit_submissions',
    'can_manage_documents',
    'can_view_documents',
    'can_edit_documents',
    'can_manage_assignees',
    'can_skip',
    'can_rollback',
    'can_manage_integrations',
    'can_manage_sourcing',
    'can_administer',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
  ],
  request_permission_set: [
    'structural_organisation',
    'grants_view',
    'grants_edit_metadata',
    'grants_manage_participants',
    'grants_pause',
    'grants_reject',
    'grants_delete',
    'grants_edit_submissions',
    'grants_manage_documents',
    'grants_view_documents',
    'grants_edit_documents',
    'grants_manage_assignees',
    'grants_skip',
    'grants_rollback',
    'grants_manage_integrations',
    'grants_manage_sourcing',
    'grants_administer',
    'grants_view_tprm',
    'grants_edit_tprm',
    'grants_manage_tprm',
    'granted_view',
    'granted_edit_metadata',
    'granted_manage_participants',
    'granted_pause',
    'granted_reject',
    'granted_manage_documents',
    'granted_view_documents',
    'granted_edit_documents',
    'granted_delete',
    'granted_edit_submissions',
    'granted_manage_assignees',
    'granted_skip',
    'granted_rollback',
    'granted_manage_integrations',
    'granted_manage_sourcing',
    'granted_administer',
    'granted_view_tprm',
    'granted_edit_tprm',
    'granted_manage_tprm',
    'grants_any',
  ],
  agreement: [
    'derived_organisation',
    'derived_scope',
    'derived_organisation_confidential',
    'derived_scope_confidential',
    'derived_supplier',
    'derived_supplier_confidential',
    'derived_owner',
    'grant',
    'derived_parent',
    'derived_parent_confidential',
    'own_view',
    'lineage_view',
    'conf_lineage_view',
    'can_view',
    'own_explicit_view',
    'lineage_explicit_view',
    'conf_lineage_explicit_view',
    'explicit_view',
    'can_edit',
    'can_cancel',
    'can_view_related_supplier',
    'can_view_related_requests',
    'conf_can_view_related_supplier',
    'conf_can_view_related_requests',
    'can_manage_renewals',
    'can_view_documents',
    'can_manage_documents',
    'can_edit_documents',
    'explicit_can_view_documents',
    'explicit_can_manage_documents',
    'explicit_can_edit_documents',
    'can_administer',
    'can_delete',
  ],
  renewal: [
    'derived_agreement',
    'derived_organisation',
    'derived_assignee',
    'linked_view',
    'explicit_view',
    'unlinked_view',
    'can_view',
    'can_manage',
  ],
  risk: ['derived_supplier', 'derived_request', 'derived_organisation', 'derived_owner', 'can_view', 'can_edit', 'can_delete'],
  agreement_grant: [
    'subject',
    'custom_set',
    'viewer_set',
    'owner_set',
    'can_view',
    'can_view_related_supplier',
    'can_view_related_requests',
    'can_view_documents',
    'can_edit',
    'can_cancel',
    'can_manage_renewals',
    'can_manage_documents',
    'can_edit_documents',
    'can_delete',
    'can_administer',
  ],
  agreement_permission_set: [
    'structural_organisation',
    'grants_view',
    'grants_edit',
    'grants_cancel',
    'grants_view_related_supplier',
    'grants_view_related_requests',
    'grants_manage_renewals',
    'grants_view_documents',
    'grants_manage_documents',
    'grants_edit_documents',
    'grants_delete',
    'grants_administer',
    'grants_any',
  ],
  document: [
    'derived_supplier',
    'derived_agreement',
    'derived_request',
    'derived_linking_request',
    'derived_uploader',
    'derived_marker',
    'viewer',
    'derived_organisation',
    'derived_organisation_confidential',
    'derived_confidential',
    'marked_viewer',
    'explicit_can_manage',
    'explicit_can_edit',
    'explicit_view',
    'can_manage',
    'can_edit',
    'can_view',
    'request_tab_view',
  ],
  document_grant: ['subject', 'viewer_set', 'editor_set', 'owner_set', 'can_view', 'can_edit', 'can_manage'],
  tprm_grant: ['subject', 'viewer_set', 'editor_set', 'owner_set', 'can_view', 'can_edit', 'can_manage'],
  bill: [
    'derived_organisation',
    'derived_pool',
    'derived_approver',
    'derived_draft_assignee',
    'derived_mention',
    'grant',
    'can_edit_before_accept',
    'can_accept',
    'can_assign',
    'can_approve',
    'can_view',
  ],
  bill_grant: ['subject', 'custom_set', 'viewer_set', 'owner_set', 'can_view', 'can_edit_before_accept', 'can_accept'],
  bill_permission_set: ['structural_organisation', 'grants_edit_before_accept', 'grants_accept', 'grants_any'],
  workflow: ['derived_organisation', 'grant', 'restricted', 'can_create_request'],
  workflow_grant: ['subject', 'custom_set', 'viewer_set', 'owner_set', 'can_create_request'],
  workflow_permission_set: ['structural_organisation', 'grants_create_request', 'grants_any'],
  insights_dashboard: [
    'derived_owner',
    'derived_org_viewer',
    'derived_org_editor',
    'derived_viewer',
    'derived_editor',
    'viewer',
    'editor',
    'derived_organisation',
    'holds_view_insights',
    'holds_manage_insights',
    'can_delete',
    'can_edit',
    'can_view',
    'can_manage_org_access',
  ],
} as const satisfies Record<FgaObjectType, readonly string[]>

export type FgaRelation<T extends FgaObjectType = FgaObjectType> = (typeof FGA_RELATIONS)[T][number]

/** Directly-assignable relations — the relations tuples may be written for. */
export const FGA_ASSIGNABLE_RELATIONS = {
  user: [],
  group: ['derived_member'],
  role: ['derived_assignee'],
  pool: ['derived_member'],
  organisation: [
    'derived_owner',
    'derived_admin',
    'derived_viewer',
    'derived_user',
    'derived_member',
    'system_admin',
    'permission_admin',
    'custom_field_admin',
    'insights_access',
    'document_grant',
    'subprocessor_grant',
    'risk_grant',
    'alert_grant',
    'supplier_grant',
    'request_grant',
    'agreement_grant',
    'bill_grant',
    'request_creator',
    'confidential_request_access',
    'confidential_supplier_access',
    'confidential_agreement_access',
  ],
  config_area: ['structural_organisation', 'manager', 'viewer'],
  sensitive_data: ['structural_organisation', 'viewer'],
  scope_dimension: ['structural_organisation', 'matching_supplier_grant', 'matching_request_grant', 'matching_agreement_grant'],
  scope_value: ['structural_dimension', 'derived_member', 'supplier_grant', 'request_grant', 'agreement_grant'],
  supplier: [
    'derived_organisation',
    'derived_scope',
    'derived_contact',
    'derived_participant_grant',
    'derived_organisation_confidential',
    'derived_scope_confidential',
    'derived_agreement',
    'derived_agreement_confidential',
    'viewer',
    'owner',
    'grant',
    'derived_parent',
    'derived_parent_confidential',
  ],
  supplier_grant: ['subject', 'custom_set', 'viewer_set', 'owner_set'],
  supplier_permission_set: [
    'structural_organisation',
    'grants_view',
    'grants_view_tprm',
    'grants_edit_tprm',
    'grants_manage_tprm',
    'grants_view_related_requests',
    'grants_view_related_agreements',
    'grants_view_related_documents',
    'grants_view_related_submissions',
    'grants_edit',
    'grants_manage_documents',
    'grants_edit_documents',
    'grants_manage_internal_contacts',
    'grants_manage_external_contacts',
    'grants_manage_products',
    'grants_create_product',
    'grants_add_agreement',
    'grants_administer',
    'grants_create',
  ],
  supplier_participant_grant: ['derived_member', 'derived_participant_set'],
  request: [
    'derived_organisation',
    'derived_scope',
    'derived_organisation_confidential',
    'derived_scope_confidential',
    'derived_supplier',
    'derived_supplier_confidential',
    'derived_agreement',
    'derived_agreement_confidential',
    'derived_requester',
    'derived_collaborator',
    'derived_rfx_owner',
    'grant',
  ],
  request_grant: ['subject', 'custom_set', 'viewer_set', 'owner_set'],
  request_permission_set: [
    'structural_organisation',
    'grants_view',
    'grants_edit_metadata',
    'grants_manage_participants',
    'grants_pause',
    'grants_reject',
    'grants_delete',
    'grants_edit_submissions',
    'grants_manage_documents',
    'grants_view_documents',
    'grants_edit_documents',
    'grants_manage_assignees',
    'grants_skip',
    'grants_rollback',
    'grants_manage_integrations',
    'grants_manage_sourcing',
    'grants_administer',
    'grants_view_tprm',
    'grants_edit_tprm',
    'grants_manage_tprm',
  ],
  agreement: [
    'derived_organisation',
    'derived_scope',
    'derived_organisation_confidential',
    'derived_scope_confidential',
    'derived_supplier',
    'derived_supplier_confidential',
    'derived_owner',
    'grant',
    'derived_parent',
    'derived_parent_confidential',
  ],
  renewal: ['derived_agreement', 'derived_organisation', 'derived_assignee'],
  risk: ['derived_supplier', 'derived_request', 'derived_organisation', 'derived_owner'],
  agreement_grant: ['subject', 'custom_set', 'viewer_set', 'owner_set'],
  agreement_permission_set: [
    'structural_organisation',
    'grants_view',
    'grants_edit',
    'grants_cancel',
    'grants_view_related_supplier',
    'grants_view_related_requests',
    'grants_manage_renewals',
    'grants_view_documents',
    'grants_manage_documents',
    'grants_edit_documents',
    'grants_delete',
    'grants_administer',
  ],
  document: [
    'derived_supplier',
    'derived_agreement',
    'derived_request',
    'derived_linking_request',
    'derived_uploader',
    'derived_marker',
    'viewer',
    'derived_organisation',
    'derived_organisation_confidential',
    'derived_confidential',
  ],
  document_grant: ['subject', 'viewer_set', 'editor_set', 'owner_set'],
  tprm_grant: ['subject', 'viewer_set', 'editor_set', 'owner_set'],
  bill: ['derived_organisation', 'derived_pool', 'derived_approver', 'derived_draft_assignee', 'derived_mention', 'grant'],
  bill_grant: ['subject', 'custom_set', 'viewer_set', 'owner_set'],
  bill_permission_set: ['structural_organisation', 'grants_edit_before_accept', 'grants_accept'],
  workflow: ['derived_organisation', 'grant', 'restricted'],
  workflow_grant: ['subject', 'custom_set', 'viewer_set', 'owner_set'],
  workflow_permission_set: ['structural_organisation', 'grants_create_request'],
  insights_dashboard: [
    'derived_owner',
    'derived_org_viewer',
    'derived_org_editor',
    'derived_viewer',
    'derived_editor',
    'viewer',
    'editor',
    'derived_organisation',
  ],
} as const satisfies Record<FgaObjectType, readonly string[]>

export type FgaAssignableRelation<T extends FgaObjectType = FgaObjectType> = (typeof FGA_ASSIGNABLE_RELATIONS)[T][number]

/** Computed/checkable relations — derived by the model and Checked by application code. */
export const FGA_COMPUTED_RELATIONS = {
  user: [],
  group: [],
  role: ['assignee'],
  pool: [],
  organisation: [
    'can_manage_permissions',
    'can_manage_custom_fields',
    'can_view_insights',
    'can_manage_insights',
    'can_manage_budgets',
    'can_manage_all_documents',
    'can_edit_all_documents',
    'can_view_all_documents',
    'conf_can_manage_all_documents',
    'conf_can_edit_all_documents',
    'conf_can_view_all_documents',
    'can_manage_all_subprocessors',
    'can_edit_all_subprocessors',
    'can_view_all_subprocessors',
    'can_manage_all_risks',
    'can_edit_all_risks',
    'can_view_all_risks',
    'conf_can_manage_all_risks',
    'conf_can_edit_all_risks',
    'conf_can_view_all_risks',
    'can_edit_all_alerts',
    'can_view_all_alerts',
    'conf_can_edit_all_alerts',
    'conf_can_view_all_alerts',
    'can_view_all_suppliers',
    'can_edit_all_suppliers',
    'can_view_tprm_all_suppliers',
    'can_edit_tprm_all_suppliers',
    'can_manage_tprm_all_suppliers',
    'can_view_related_requests_all_suppliers',
    'can_view_related_agreements_all_suppliers',
    'can_view_related_documents_all_suppliers',
    'can_view_related_submissions_all_suppliers',
    'can_manage_documents_all_suppliers',
    'can_edit_documents_all_suppliers',
    'can_manage_internal_contacts_all_suppliers',
    'can_manage_external_contacts_all_suppliers',
    'can_manage_products_all_suppliers',
    'can_create_product_all_suppliers',
    'can_add_agreement_all_suppliers',
    'can_administer_all_suppliers',
    'can_create_supplier',
    'can_view_all_requests',
    'can_view_tprm_all_requests',
    'can_edit_tprm_all_requests',
    'can_manage_tprm_all_requests',
    'can_edit_metadata_all_requests',
    'can_manage_participants_all_requests',
    'can_pause_all_requests',
    'can_reject_all_requests',
    'can_delete_all_requests',
    'can_edit_submissions_all_requests',
    'can_manage_documents_all_requests',
    'can_view_documents_all_requests',
    'can_edit_documents_all_requests',
    'can_manage_assignees_all_requests',
    'can_skip_all_requests',
    'can_rollback_all_requests',
    'can_manage_integrations_all_requests',
    'can_manage_sourcing_all_requests',
    'can_administer_all_requests',
    'can_create_request',
    'confidential_document_access',
    'conf_can_view_all_requests',
    'conf_can_view_tprm_all_requests',
    'conf_can_edit_tprm_all_requests',
    'conf_can_manage_tprm_all_requests',
    'conf_can_edit_metadata_all_requests',
    'conf_can_manage_participants_all_requests',
    'conf_can_pause_all_requests',
    'conf_can_reject_all_requests',
    'conf_can_delete_all_requests',
    'conf_can_edit_submissions_all_requests',
    'conf_can_manage_documents_all_requests',
    'conf_can_view_documents_all_requests',
    'conf_can_edit_documents_all_requests',
    'conf_can_manage_assignees_all_requests',
    'conf_can_skip_all_requests',
    'conf_can_rollback_all_requests',
    'conf_can_manage_integrations_all_requests',
    'conf_can_manage_sourcing_all_requests',
    'conf_can_administer_all_requests',
    'conf_can_view_all_suppliers',
    'conf_can_edit_all_suppliers',
    'conf_can_view_tprm_all_suppliers',
    'conf_can_edit_tprm_all_suppliers',
    'conf_can_manage_tprm_all_suppliers',
    'conf_can_view_related_requests_all_suppliers',
    'conf_can_view_related_agreements_all_suppliers',
    'conf_can_view_related_documents_all_suppliers',
    'conf_can_view_related_submissions_all_suppliers',
    'conf_can_manage_documents_all_suppliers',
    'conf_can_edit_documents_all_suppliers',
    'conf_can_manage_internal_contacts_all_suppliers',
    'conf_can_manage_external_contacts_all_suppliers',
    'conf_can_manage_products_all_suppliers',
    'conf_can_create_product_all_suppliers',
    'conf_can_add_agreement_all_suppliers',
    'conf_can_administer_all_suppliers',
    'can_view_all_agreements',
    'can_edit_all_agreements',
    'can_view_related_supplier_all_agreements',
    'can_view_related_requests_all_agreements',
    'can_view_documents_all_agreements',
    'can_cancel_all_agreements',
    'can_manage_renewals_all_agreements',
    'can_manage_documents_all_agreements',
    'can_edit_documents_all_agreements',
    'can_delete_all_agreements',
    'can_administer_all_agreements',
    'can_view_all_bills',
    'can_edit_before_accept_all_bills',
    'can_accept_all_bills',
    'conf_can_view_all_agreements',
    'conf_can_edit_all_agreements',
    'conf_can_cancel_all_agreements',
    'conf_can_view_related_supplier_all_agreements',
    'conf_can_view_related_requests_all_agreements',
    'conf_can_manage_renewals_all_agreements',
    'conf_can_view_documents_all_agreements',
    'conf_can_manage_documents_all_agreements',
    'conf_can_edit_documents_all_agreements',
    'conf_can_delete_all_agreements',
    'conf_can_administer_all_agreements',
  ],
  config_area: ['can_manage', 'can_view'],
  sensitive_data: ['can_view'],
  scope_dimension: [
    'confidential_request_access',
    'confidential_supplier_access',
    'confidential_agreement_access',
    'matching_can_view_supplier',
    'matching_can_view_tprm',
    'matching_can_edit_tprm',
    'matching_can_manage_tprm',
    'matching_can_view_related_requests',
    'matching_can_view_related_agreements',
    'matching_can_view_related_documents',
    'matching_can_view_related_submissions',
    'matching_can_edit',
    'matching_can_manage_documents',
    'matching_can_edit_documents',
    'matching_can_manage_internal_contacts',
    'matching_can_manage_external_contacts',
    'matching_can_manage_products',
    'matching_can_create_product',
    'matching_can_add_agreement',
    'matching_can_administer',
    'matching_can_view_request',
    'matching_can_view_tprm_request',
    'matching_can_edit_tprm_request',
    'matching_can_manage_tprm_request',
    'matching_can_edit_metadata_request',
    'matching_can_manage_participants_request',
    'matching_can_pause_request',
    'matching_can_reject_request',
    'matching_can_delete_request',
    'matching_can_edit_submissions_request',
    'matching_can_manage_documents_request',
    'matching_can_view_documents_request',
    'matching_can_edit_documents_request',
    'matching_can_manage_assignees_request',
    'matching_can_skip_request',
    'matching_can_rollback_request',
    'matching_can_manage_integrations_request',
    'matching_can_manage_sourcing_request',
    'matching_can_administer_request',
    'matching_can_view_agreement',
    'matching_can_view_related_supplier_agreement',
    'matching_can_view_related_requests_agreement',
    'matching_can_view_documents_agreement',
    'matching_can_edit_agreement',
    'matching_can_cancel_agreement',
    'matching_can_manage_renewals_agreement',
    'matching_can_manage_documents_agreement',
    'matching_can_edit_documents_agreement',
    'matching_can_delete_agreement',
    'matching_can_administer_agreement',
  ],
  scope_value: [
    'confidential_request_access',
    'confidential_supplier_access',
    'confidential_agreement_access',
    'confers_view_supplier',
    'confers_view_tprm',
    'confers_edit_tprm',
    'confers_manage_tprm',
    'confers_view_related_requests',
    'confers_view_related_agreements',
    'confers_view_related_documents',
    'confers_view_related_submissions',
    'confers_edit',
    'confers_manage_documents',
    'confers_edit_documents',
    'confers_manage_internal_contacts',
    'confers_manage_external_contacts',
    'confers_manage_products',
    'confers_create_product',
    'confers_add_agreement',
    'confers_administer',
    'confers_view_request',
    'confers_view_tprm_request',
    'confers_edit_tprm_request',
    'confers_manage_tprm_request',
    'confers_edit_metadata_request',
    'confers_manage_participants_request',
    'confers_pause_request',
    'confers_reject_request',
    'confers_delete_request',
    'confers_edit_submissions_request',
    'confers_manage_documents_request',
    'confers_view_documents_request',
    'confers_edit_documents_request',
    'confers_manage_assignees_request',
    'confers_skip_request',
    'confers_rollback_request',
    'confers_manage_integrations_request',
    'confers_manage_sourcing_request',
    'confers_administer_request',
    'conf_confers_view_supplier',
    'conf_confers_edit',
    'conf_confers_view_tprm',
    'conf_confers_edit_tprm',
    'conf_confers_manage_tprm',
    'conf_confers_view_related_requests',
    'conf_confers_view_related_agreements',
    'conf_confers_view_related_documents',
    'conf_confers_view_related_submissions',
    'conf_confers_manage_documents',
    'conf_confers_edit_documents',
    'conf_confers_manage_internal_contacts',
    'conf_confers_manage_external_contacts',
    'conf_confers_manage_products',
    'conf_confers_create_product',
    'conf_confers_add_agreement',
    'conf_confers_administer',
    'conf_confers_view_request',
    'conf_confers_view_tprm_request',
    'conf_confers_edit_tprm_request',
    'conf_confers_manage_tprm_request',
    'conf_confers_edit_metadata_request',
    'conf_confers_manage_participants_request',
    'conf_confers_pause_request',
    'conf_confers_reject_request',
    'conf_confers_delete_request',
    'conf_confers_edit_submissions_request',
    'conf_confers_manage_documents_request',
    'conf_confers_view_documents_request',
    'conf_confers_edit_documents_request',
    'conf_confers_manage_assignees_request',
    'conf_confers_skip_request',
    'conf_confers_rollback_request',
    'conf_confers_manage_integrations_request',
    'conf_confers_manage_sourcing_request',
    'conf_confers_administer_request',
    'confers_view_agreement',
    'confers_view_related_supplier_agreement',
    'confers_view_related_requests_agreement',
    'confers_view_documents_agreement',
    'confers_edit_agreement',
    'confers_cancel_agreement',
    'confers_manage_renewals_agreement',
    'confers_manage_documents_agreement',
    'confers_edit_documents_agreement',
    'confers_delete_agreement',
    'confers_administer_agreement',
    'conf_confers_view_agreement',
    'conf_confers_edit_agreement',
    'conf_confers_cancel_agreement',
    'conf_confers_view_related_supplier_agreement',
    'conf_confers_view_related_requests_agreement',
    'conf_confers_manage_renewals_agreement',
    'conf_confers_view_documents_agreement',
    'conf_confers_manage_documents_agreement',
    'conf_confers_edit_documents_agreement',
    'conf_confers_delete_agreement',
    'conf_confers_administer_agreement',
  ],
  supplier: [
    'contact_view',
    'contact_view_tprm',
    'contact_edit_tprm',
    'contact_manage_tprm',
    'contact_view_related_requests',
    'contact_view_related_agreements',
    'contact_view_related_documents',
    'contact_view_related_submissions',
    'contact_edit',
    'contact_edit_documents',
    'contact_manage_documents',
    'contact_manage_internal_contacts',
    'contact_manage_external_contacts',
    'contact_manage_products',
    'contact_create_product',
    'contact_add_agreement',
    'contact_administer',
    'own_view',
    'lineage_view',
    'conf_lineage_view',
    'can_view',
    'own_explicit_view',
    'lineage_explicit_view',
    'conf_lineage_explicit_view',
    'explicit_view',
    'can_edit',
    'can_view_subprocessors',
    'can_edit_subprocessors',
    'can_manage_subprocessors',
    'can_view_risks',
    'can_edit_risks',
    'can_manage_risks',
    'can_view_alerts',
    'can_edit_alerts',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
    'can_view_related_requests',
    'can_view_related_agreements',
    'conf_can_view_related_requests',
    'conf_can_view_related_agreements',
    'explicit_can_view_related_requests',
    'explicit_can_view_related_agreements',
    'can_view_related_documents',
    'can_view_related_submissions',
    'can_manage_documents',
    'can_edit_documents',
    'explicit_can_view_related_documents',
    'explicit_can_manage_documents',
    'explicit_can_edit_documents',
    'can_manage_internal_contacts',
    'can_manage_external_contacts',
    'can_manage_products',
    'can_create_product',
    'can_add_agreement',
    'can_administer',
  ],
  supplier_grant: [
    'can_view',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
    'can_view_related_requests',
    'can_view_related_agreements',
    'can_view_related_documents',
    'can_view_related_submissions',
    'can_edit',
    'can_manage_documents',
    'can_edit_documents',
    'can_manage_internal_contacts',
    'can_manage_external_contacts',
    'can_manage_products',
    'can_create_product',
    'can_add_agreement',
    'can_create',
    'can_administer',
  ],
  supplier_permission_set: ['grants_any'],
  supplier_participant_grant: [
    'can_view',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
    'can_view_related_requests',
    'can_view_related_agreements',
    'can_view_related_documents',
    'can_view_related_submissions',
    'can_edit',
    'can_edit_documents',
    'can_manage_documents',
    'can_manage_internal_contacts',
    'can_manage_external_contacts',
    'can_manage_products',
    'can_create_product',
    'can_add_agreement',
    'can_administer',
  ],
  request: [
    'explicit_view',
    'can_view',
    'can_edit_metadata',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
    'can_view_risks',
    'can_edit_risks',
    'can_manage_risks',
    'can_edit_po_number',
    'can_manage_participants',
    'can_manage_followers',
    'can_pause',
    'can_manage_documents',
    'can_view_documents',
    'can_edit_documents',
    'explicit_can_manage_documents',
    'explicit_can_view_documents',
    'explicit_can_edit_documents',
    'can_manage_sourcing_granted',
    'can_manage_sourcing',
    'can_reject',
    'can_delete',
    'can_edit_submissions',
    'can_manage_assignees',
    'can_skip',
    'can_rollback',
    'can_manage_integrations',
    'can_administer',
  ],
  request_grant: [
    'can_view',
    'can_edit_metadata',
    'can_manage_participants',
    'can_pause',
    'can_reject',
    'can_delete',
    'can_edit_submissions',
    'can_manage_documents',
    'can_view_documents',
    'can_edit_documents',
    'can_manage_assignees',
    'can_skip',
    'can_rollback',
    'can_manage_integrations',
    'can_manage_sourcing',
    'can_administer',
    'can_view_tprm',
    'can_edit_tprm',
    'can_manage_tprm',
  ],
  request_permission_set: [
    'granted_view',
    'granted_edit_metadata',
    'granted_manage_participants',
    'granted_pause',
    'granted_reject',
    'granted_manage_documents',
    'granted_view_documents',
    'granted_edit_documents',
    'granted_delete',
    'granted_edit_submissions',
    'granted_manage_assignees',
    'granted_skip',
    'granted_rollback',
    'granted_manage_integrations',
    'granted_manage_sourcing',
    'granted_administer',
    'granted_view_tprm',
    'granted_edit_tprm',
    'granted_manage_tprm',
    'grants_any',
  ],
  agreement: [
    'own_view',
    'lineage_view',
    'conf_lineage_view',
    'can_view',
    'own_explicit_view',
    'lineage_explicit_view',
    'conf_lineage_explicit_view',
    'explicit_view',
    'can_edit',
    'can_cancel',
    'can_view_related_supplier',
    'can_view_related_requests',
    'conf_can_view_related_supplier',
    'conf_can_view_related_requests',
    'can_manage_renewals',
    'can_view_documents',
    'can_manage_documents',
    'can_edit_documents',
    'explicit_can_view_documents',
    'explicit_can_manage_documents',
    'explicit_can_edit_documents',
    'can_administer',
    'can_delete',
  ],
  renewal: ['linked_view', 'explicit_view', 'unlinked_view', 'can_view', 'can_manage'],
  risk: ['can_view', 'can_edit', 'can_delete'],
  agreement_grant: [
    'can_view',
    'can_view_related_supplier',
    'can_view_related_requests',
    'can_view_documents',
    'can_edit',
    'can_cancel',
    'can_manage_renewals',
    'can_manage_documents',
    'can_edit_documents',
    'can_delete',
    'can_administer',
  ],
  agreement_permission_set: ['grants_any'],
  document: [
    'marked_viewer',
    'explicit_can_manage',
    'explicit_can_edit',
    'explicit_view',
    'can_manage',
    'can_edit',
    'can_view',
    'request_tab_view',
  ],
  document_grant: ['can_view', 'can_edit', 'can_manage'],
  tprm_grant: ['can_view', 'can_edit', 'can_manage'],
  bill: ['can_edit_before_accept', 'can_accept', 'can_assign', 'can_approve', 'can_view'],
  bill_grant: ['can_view', 'can_edit_before_accept', 'can_accept'],
  bill_permission_set: ['grants_any'],
  workflow: ['can_create_request'],
  workflow_grant: ['can_create_request'],
  workflow_permission_set: ['grants_any'],
  insights_dashboard: [
    'holds_view_insights',
    'holds_manage_insights',
    'can_delete',
    'can_edit',
    'can_view',
    'can_manage_org_access',
  ],
} as const satisfies Record<FgaObjectType, readonly string[]>

export type FgaComputedRelation<T extends FgaObjectType = FgaObjectType> = (typeof FGA_COMPUTED_RELATIONS)[T][number]

/** An object reference string, e.g. `config_area:acme/core_data`. */
export type FgaObjectRef<T extends FgaObjectType = FgaObjectType> = `${T}:${string}`

/** The `can_*` verbs each relation confers on its own type, following same-object relations. */
export const FGA_VERBS_BY_RELATION = {
  organisation: {
    derived_owner: [
      'can_manage_permissions',
      'can_manage_custom_fields',
      'can_view_insights',
      'can_manage_insights',
      'can_manage_budgets',
      'can_manage_all_documents',
      'can_edit_all_documents',
      'can_view_all_documents',
      'can_manage_all_subprocessors',
      'can_edit_all_subprocessors',
      'can_view_all_subprocessors',
      'can_manage_all_risks',
      'can_edit_all_risks',
      'can_view_all_risks',
      'can_edit_all_alerts',
      'can_view_all_alerts',
      'can_view_all_suppliers',
      'can_edit_all_suppliers',
      'can_view_tprm_all_suppliers',
      'can_edit_tprm_all_suppliers',
      'can_manage_tprm_all_suppliers',
      'can_view_related_requests_all_suppliers',
      'can_view_related_agreements_all_suppliers',
      'can_view_related_documents_all_suppliers',
      'can_view_related_submissions_all_suppliers',
      'can_manage_documents_all_suppliers',
      'can_edit_documents_all_suppliers',
      'can_manage_internal_contacts_all_suppliers',
      'can_manage_external_contacts_all_suppliers',
      'can_manage_products_all_suppliers',
      'can_create_product_all_suppliers',
      'can_add_agreement_all_suppliers',
      'can_administer_all_suppliers',
      'can_create_supplier',
      'can_view_all_requests',
      'can_view_tprm_all_requests',
      'can_edit_tprm_all_requests',
      'can_manage_tprm_all_requests',
      'can_edit_metadata_all_requests',
      'can_manage_participants_all_requests',
      'can_pause_all_requests',
      'can_reject_all_requests',
      'can_delete_all_requests',
      'can_edit_submissions_all_requests',
      'can_manage_documents_all_requests',
      'can_view_documents_all_requests',
      'can_edit_documents_all_requests',
      'can_manage_assignees_all_requests',
      'can_skip_all_requests',
      'can_rollback_all_requests',
      'can_manage_integrations_all_requests',
      'can_manage_sourcing_all_requests',
      'can_administer_all_requests',
      'can_create_request',
      'can_view_all_agreements',
      'can_edit_all_agreements',
      'can_view_related_supplier_all_agreements',
      'can_view_related_requests_all_agreements',
      'can_view_documents_all_agreements',
      'can_cancel_all_agreements',
      'can_manage_renewals_all_agreements',
      'can_manage_documents_all_agreements',
      'can_edit_documents_all_agreements',
      'can_delete_all_agreements',
      'can_administer_all_agreements',
      'can_view_all_bills',
      'can_edit_before_accept_all_bills',
      'can_accept_all_bills',
    ],
    derived_admin: [
      'can_view_insights',
      'can_manage_insights',
      'can_manage_budgets',
      'can_manage_all_documents',
      'can_edit_all_documents',
      'can_view_all_documents',
      'can_manage_all_subprocessors',
      'can_edit_all_subprocessors',
      'can_view_all_subprocessors',
      'can_manage_all_risks',
      'can_edit_all_risks',
      'can_view_all_risks',
      'can_edit_all_alerts',
      'can_view_all_alerts',
      'can_view_all_suppliers',
      'can_edit_all_suppliers',
      'can_view_tprm_all_suppliers',
      'can_edit_tprm_all_suppliers',
      'can_manage_tprm_all_suppliers',
      'can_view_related_requests_all_suppliers',
      'can_view_related_agreements_all_suppliers',
      'can_view_related_documents_all_suppliers',
      'can_view_related_submissions_all_suppliers',
      'can_manage_documents_all_suppliers',
      'can_edit_documents_all_suppliers',
      'can_manage_internal_contacts_all_suppliers',
      'can_manage_external_contacts_all_suppliers',
      'can_manage_products_all_suppliers',
      'can_create_product_all_suppliers',
      'can_add_agreement_all_suppliers',
      'can_administer_all_suppliers',
      'can_create_supplier',
      'can_view_all_requests',
      'can_view_tprm_all_requests',
      'can_edit_tprm_all_requests',
      'can_manage_tprm_all_requests',
      'can_edit_metadata_all_requests',
      'can_manage_participants_all_requests',
      'can_pause_all_requests',
      'can_reject_all_requests',
      'can_delete_all_requests',
      'can_edit_submissions_all_requests',
      'can_manage_documents_all_requests',
      'can_view_documents_all_requests',
      'can_edit_documents_all_requests',
      'can_manage_assignees_all_requests',
      'can_skip_all_requests',
      'can_rollback_all_requests',
      'can_manage_integrations_all_requests',
      'can_manage_sourcing_all_requests',
      'can_create_request',
      'can_view_all_agreements',
      'can_edit_all_agreements',
      'can_view_related_supplier_all_agreements',
      'can_view_related_requests_all_agreements',
      'can_view_documents_all_agreements',
      'can_cancel_all_agreements',
      'can_manage_renewals_all_agreements',
      'can_manage_documents_all_agreements',
      'can_edit_documents_all_agreements',
      'can_delete_all_agreements',
      'can_administer_all_agreements',
      'can_view_all_bills',
      'can_edit_before_accept_all_bills',
      'can_accept_all_bills',
    ],
    derived_viewer: [
      'can_view_insights',
      'can_view_all_documents',
      'can_view_all_subprocessors',
      'can_view_all_risks',
      'can_view_all_alerts',
      'can_view_all_suppliers',
      'can_view_tprm_all_suppliers',
      'can_view_related_requests_all_suppliers',
      'can_view_related_agreements_all_suppliers',
      'can_view_related_documents_all_suppliers',
      'can_view_related_submissions_all_suppliers',
      'can_view_all_requests',
      'can_view_tprm_all_requests',
      'can_view_documents_all_requests',
      'can_create_request',
      'can_view_all_agreements',
      'can_view_related_supplier_all_agreements',
      'can_view_related_requests_all_agreements',
      'can_view_documents_all_agreements',
      'can_view_all_bills',
    ],
    derived_user: ['can_create_request'],
    system_admin: [
      'can_manage_permissions',
      'can_manage_custom_fields',
      'can_view_insights',
      'can_manage_insights',
      'can_manage_budgets',
      'can_manage_all_documents',
      'can_edit_all_documents',
      'can_view_all_documents',
      'can_manage_all_subprocessors',
      'can_edit_all_subprocessors',
      'can_view_all_subprocessors',
      'can_manage_all_risks',
      'can_edit_all_risks',
      'can_view_all_risks',
      'can_edit_all_alerts',
      'can_view_all_alerts',
      'can_view_all_suppliers',
      'can_edit_all_suppliers',
      'can_view_tprm_all_suppliers',
      'can_edit_tprm_all_suppliers',
      'can_manage_tprm_all_suppliers',
      'can_view_related_requests_all_suppliers',
      'can_view_related_agreements_all_suppliers',
      'can_view_related_documents_all_suppliers',
      'can_view_related_submissions_all_suppliers',
      'can_manage_documents_all_suppliers',
      'can_edit_documents_all_suppliers',
      'can_manage_internal_contacts_all_suppliers',
      'can_manage_external_contacts_all_suppliers',
      'can_manage_products_all_suppliers',
      'can_create_product_all_suppliers',
      'can_add_agreement_all_suppliers',
      'can_administer_all_suppliers',
      'can_create_supplier',
      'can_view_all_requests',
      'can_view_tprm_all_requests',
      'can_edit_tprm_all_requests',
      'can_manage_tprm_all_requests',
      'can_edit_metadata_all_requests',
      'can_manage_participants_all_requests',
      'can_pause_all_requests',
      'can_reject_all_requests',
      'can_delete_all_requests',
      'can_edit_submissions_all_requests',
      'can_manage_documents_all_requests',
      'can_view_documents_all_requests',
      'can_edit_documents_all_requests',
      'can_manage_assignees_all_requests',
      'can_skip_all_requests',
      'can_rollback_all_requests',
      'can_manage_integrations_all_requests',
      'can_manage_sourcing_all_requests',
      'can_administer_all_requests',
      'can_create_request',
      'can_view_all_agreements',
      'can_edit_all_agreements',
      'can_view_related_supplier_all_agreements',
      'can_view_related_requests_all_agreements',
      'can_view_documents_all_agreements',
      'can_cancel_all_agreements',
      'can_manage_renewals_all_agreements',
      'can_manage_documents_all_agreements',
      'can_edit_documents_all_agreements',
      'can_delete_all_agreements',
      'can_administer_all_agreements',
      'can_view_all_bills',
      'can_edit_before_accept_all_bills',
      'can_accept_all_bills',
    ],
    permission_admin: ['can_manage_permissions'],
    can_manage_permissions: ['can_manage_permissions'],
    custom_field_admin: ['can_manage_custom_fields'],
    can_manage_custom_fields: ['can_manage_custom_fields'],
    insights_access: ['can_view_insights', 'can_manage_insights'],
    can_view_insights: ['can_view_insights'],
    can_manage_insights: ['can_manage_insights'],
    can_manage_budgets: ['can_manage_budgets'],
    can_manage_all_documents: ['can_manage_all_documents'],
    can_edit_all_documents: ['can_edit_all_documents'],
    can_view_all_documents: ['can_view_all_documents'],
    can_manage_all_subprocessors: ['can_manage_all_subprocessors'],
    can_edit_all_subprocessors: ['can_edit_all_subprocessors'],
    can_view_all_subprocessors: ['can_view_all_subprocessors'],
    can_manage_all_risks: ['can_manage_all_risks'],
    can_edit_all_risks: ['can_edit_all_risks'],
    can_view_all_risks: ['can_view_all_risks'],
    can_edit_all_alerts: ['can_edit_all_alerts'],
    can_view_all_alerts: ['can_view_all_alerts'],
    can_view_all_suppliers: ['can_view_all_suppliers'],
    can_edit_all_suppliers: ['can_edit_all_suppliers'],
    can_view_tprm_all_suppliers: ['can_view_tprm_all_suppliers'],
    can_edit_tprm_all_suppliers: ['can_edit_tprm_all_suppliers'],
    can_manage_tprm_all_suppliers: ['can_manage_tprm_all_suppliers'],
    can_view_related_requests_all_suppliers: ['can_view_related_requests_all_suppliers'],
    can_view_related_agreements_all_suppliers: ['can_view_related_agreements_all_suppliers'],
    can_view_related_documents_all_suppliers: ['can_view_related_documents_all_suppliers'],
    can_view_related_submissions_all_suppliers: ['can_view_related_submissions_all_suppliers'],
    can_manage_documents_all_suppliers: ['can_manage_documents_all_suppliers'],
    can_edit_documents_all_suppliers: ['can_edit_documents_all_suppliers'],
    can_manage_internal_contacts_all_suppliers: ['can_manage_internal_contacts_all_suppliers'],
    can_manage_external_contacts_all_suppliers: ['can_manage_external_contacts_all_suppliers'],
    can_manage_products_all_suppliers: ['can_manage_products_all_suppliers'],
    can_create_product_all_suppliers: ['can_create_product_all_suppliers'],
    can_add_agreement_all_suppliers: ['can_add_agreement_all_suppliers'],
    can_administer_all_suppliers: ['can_administer_all_suppliers'],
    can_create_supplier: ['can_create_supplier'],
    can_view_all_requests: ['can_view_all_requests'],
    can_view_tprm_all_requests: ['can_view_tprm_all_requests'],
    can_edit_tprm_all_requests: ['can_edit_tprm_all_requests'],
    can_manage_tprm_all_requests: ['can_manage_tprm_all_requests'],
    can_edit_metadata_all_requests: ['can_edit_metadata_all_requests'],
    can_manage_participants_all_requests: ['can_manage_participants_all_requests'],
    can_pause_all_requests: ['can_pause_all_requests'],
    can_reject_all_requests: ['can_reject_all_requests'],
    can_delete_all_requests: ['can_delete_all_requests'],
    can_edit_submissions_all_requests: ['can_edit_submissions_all_requests'],
    can_manage_documents_all_requests: ['can_manage_documents_all_requests'],
    can_view_documents_all_requests: ['can_view_documents_all_requests'],
    can_edit_documents_all_requests: ['can_edit_documents_all_requests'],
    can_manage_assignees_all_requests: ['can_manage_assignees_all_requests'],
    can_skip_all_requests: ['can_skip_all_requests'],
    can_rollback_all_requests: ['can_rollback_all_requests'],
    can_manage_integrations_all_requests: ['can_manage_integrations_all_requests'],
    can_manage_sourcing_all_requests: ['can_manage_sourcing_all_requests'],
    can_administer_all_requests: ['can_administer_all_requests'],
    request_creator: ['can_create_request'],
    can_create_request: ['can_create_request'],
    can_view_all_agreements: ['can_view_all_agreements'],
    can_edit_all_agreements: ['can_edit_all_agreements'],
    can_view_related_supplier_all_agreements: ['can_view_related_supplier_all_agreements'],
    can_view_related_requests_all_agreements: ['can_view_related_requests_all_agreements'],
    can_view_documents_all_agreements: ['can_view_documents_all_agreements'],
    can_cancel_all_agreements: ['can_cancel_all_agreements'],
    can_manage_renewals_all_agreements: ['can_manage_renewals_all_agreements'],
    can_manage_documents_all_agreements: ['can_manage_documents_all_agreements'],
    can_edit_documents_all_agreements: ['can_edit_documents_all_agreements'],
    can_delete_all_agreements: ['can_delete_all_agreements'],
    can_administer_all_agreements: ['can_administer_all_agreements'],
    can_view_all_bills: ['can_view_all_bills'],
    can_edit_before_accept_all_bills: ['can_edit_before_accept_all_bills'],
    can_accept_all_bills: ['can_accept_all_bills'],
  },
  config_area: {
    manager: ['can_manage', 'can_view'],
    viewer: ['can_view'],
    can_manage: ['can_manage', 'can_view'],
    can_view: ['can_view'],
  },
  sensitive_data: {
    viewer: ['can_view'],
    can_view: ['can_view'],
  },
  supplier: {
    viewer: ['can_view'],
    owner: [
      'can_view',
      'can_edit',
      'can_view_subprocessors',
      'can_edit_subprocessors',
      'can_manage_subprocessors',
      'can_view_risks',
      'can_edit_risks',
      'can_manage_risks',
      'can_view_alerts',
      'can_edit_alerts',
      'can_view_tprm',
      'can_edit_tprm',
      'can_manage_tprm',
      'can_view_related_requests',
      'can_view_related_agreements',
      'can_view_related_documents',
      'can_view_related_submissions',
      'can_manage_documents',
      'can_edit_documents',
      'can_manage_internal_contacts',
      'can_manage_external_contacts',
      'can_manage_products',
      'can_create_product',
      'can_add_agreement',
      'can_administer',
    ],
    contact_view: ['can_view'],
    contact_view_tprm: ['can_view_subprocessors', 'can_view_risks', 'can_view_alerts', 'can_view_tprm'],
    contact_edit_tprm: [
      'can_view_subprocessors',
      'can_edit_subprocessors',
      'can_view_risks',
      'can_edit_risks',
      'can_view_alerts',
      'can_edit_alerts',
      'can_view_tprm',
      'can_edit_tprm',
    ],
    contact_manage_tprm: [
      'can_view_subprocessors',
      'can_edit_subprocessors',
      'can_manage_subprocessors',
      'can_view_risks',
      'can_edit_risks',
      'can_manage_risks',
      'can_view_alerts',
      'can_edit_alerts',
      'can_view_tprm',
      'can_edit_tprm',
      'can_manage_tprm',
    ],
    contact_view_related_requests: ['can_view_related_requests'],
    contact_view_related_agreements: ['can_view_related_agreements'],
    contact_view_related_documents: ['can_view_related_documents'],
    contact_view_related_submissions: ['can_view_related_submissions'],
    contact_edit: ['can_edit'],
    contact_edit_documents: ['can_view_related_documents', 'can_edit_documents'],
    contact_manage_documents: ['can_view_related_documents', 'can_manage_documents', 'can_edit_documents'],
    contact_manage_internal_contacts: ['can_manage_internal_contacts'],
    contact_manage_external_contacts: ['can_manage_external_contacts'],
    contact_manage_products: ['can_manage_products', 'can_create_product'],
    contact_create_product: ['can_create_product'],
    contact_add_agreement: ['can_add_agreement'],
    contact_administer: ['can_administer'],
    own_view: ['can_view'],
    conf_lineage_view: ['can_view'],
    can_view: ['can_view'],
    can_edit: ['can_edit'],
    can_view_subprocessors: ['can_view_subprocessors'],
    can_edit_subprocessors: ['can_edit_subprocessors'],
    can_manage_subprocessors: ['can_manage_subprocessors'],
    can_view_risks: ['can_view_risks'],
    can_edit_risks: ['can_edit_risks'],
    can_manage_risks: ['can_manage_risks'],
    can_view_alerts: ['can_view_alerts'],
    can_edit_alerts: ['can_edit_alerts'],
    can_view_tprm: ['can_view_subprocessors', 'can_view_risks', 'can_view_alerts', 'can_view_tprm'],
    can_edit_tprm: [
      'can_view_subprocessors',
      'can_edit_subprocessors',
      'can_view_risks',
      'can_edit_risks',
      'can_view_alerts',
      'can_edit_alerts',
      'can_view_tprm',
      'can_edit_tprm',
    ],
    can_manage_tprm: [
      'can_view_subprocessors',
      'can_edit_subprocessors',
      'can_manage_subprocessors',
      'can_view_risks',
      'can_edit_risks',
      'can_manage_risks',
      'can_view_alerts',
      'can_edit_alerts',
      'can_view_tprm',
      'can_edit_tprm',
      'can_manage_tprm',
    ],
    can_view_related_requests: ['can_view_related_requests'],
    can_view_related_agreements: ['can_view_related_agreements'],
    can_view_related_documents: ['can_view_related_documents'],
    can_view_related_submissions: ['can_view_related_submissions'],
    can_manage_documents: ['can_view_related_documents', 'can_manage_documents', 'can_edit_documents'],
    can_edit_documents: ['can_view_related_documents', 'can_edit_documents'],
    can_manage_internal_contacts: ['can_manage_internal_contacts'],
    can_manage_external_contacts: ['can_manage_external_contacts'],
    can_manage_products: ['can_manage_products', 'can_create_product'],
    can_create_product: ['can_create_product'],
    can_add_agreement: ['can_add_agreement'],
    can_administer: ['can_administer'],
  },
  supplier_grant: {
    can_view: ['can_view'],
    can_view_tprm: ['can_view_tprm'],
    can_edit_tprm: ['can_edit_tprm'],
    can_manage_tprm: ['can_manage_tprm'],
    can_view_related_requests: ['can_view_related_requests'],
    can_view_related_agreements: ['can_view_related_agreements'],
    can_view_related_documents: ['can_view_related_documents'],
    can_view_related_submissions: ['can_view_related_submissions'],
    can_edit: ['can_edit'],
    can_manage_documents: ['can_manage_documents'],
    can_edit_documents: ['can_edit_documents'],
    can_manage_internal_contacts: ['can_manage_internal_contacts'],
    can_manage_external_contacts: ['can_manage_external_contacts'],
    can_manage_products: ['can_manage_products'],
    can_create_product: ['can_create_product'],
    can_add_agreement: ['can_add_agreement'],
    can_create: ['can_create'],
    can_administer: ['can_administer'],
  },
  supplier_participant_grant: {
    can_view: ['can_view'],
    can_view_tprm: ['can_view_tprm'],
    can_edit_tprm: ['can_edit_tprm'],
    can_manage_tprm: ['can_manage_tprm'],
    can_view_related_requests: ['can_view_related_requests'],
    can_view_related_agreements: ['can_view_related_agreements'],
    can_view_related_documents: ['can_view_related_documents'],
    can_view_related_submissions: ['can_view_related_submissions'],
    can_edit: ['can_edit'],
    can_edit_documents: ['can_edit_documents'],
    can_manage_documents: ['can_manage_documents'],
    can_manage_internal_contacts: ['can_manage_internal_contacts'],
    can_manage_external_contacts: ['can_manage_external_contacts'],
    can_manage_products: ['can_manage_products'],
    can_create_product: ['can_create_product'],
    can_add_agreement: ['can_add_agreement'],
    can_administer: ['can_administer'],
  },
  request: {
    derived_requester: [
      'can_view',
      'can_edit_po_number',
      'can_manage_followers',
      'can_pause',
      'can_manage_documents',
      'can_view_documents',
      'can_edit_documents',
    ],
    derived_collaborator: ['can_view', 'can_manage_followers', 'can_pause', 'can_view_documents', 'can_edit_documents'],
    derived_rfx_owner: ['can_manage_sourcing'],
    can_view: ['can_view'],
    can_edit_metadata: ['can_edit_metadata', 'can_edit_po_number'],
    can_view_tprm: ['can_view_tprm', 'can_view_risks'],
    can_edit_tprm: ['can_view_tprm', 'can_edit_tprm', 'can_view_risks', 'can_edit_risks'],
    can_manage_tprm: [
      'can_view_tprm',
      'can_edit_tprm',
      'can_manage_tprm',
      'can_view_risks',
      'can_edit_risks',
      'can_manage_risks',
    ],
    can_view_risks: ['can_view_risks'],
    can_edit_risks: ['can_edit_risks'],
    can_manage_risks: ['can_manage_risks'],
    can_edit_po_number: ['can_edit_po_number'],
    can_manage_participants: ['can_manage_participants', 'can_manage_followers'],
    can_manage_followers: ['can_manage_followers'],
    can_pause: ['can_pause'],
    can_manage_documents: ['can_manage_documents', 'can_view_documents', 'can_edit_documents'],
    can_view_documents: ['can_view_documents'],
    can_edit_documents: ['can_view_documents', 'can_edit_documents'],
    can_manage_sourcing_granted: ['can_manage_sourcing_granted'],
    can_manage_sourcing: ['can_manage_sourcing'],
    can_reject: ['can_reject'],
    can_delete: ['can_delete'],
    can_edit_submissions: ['can_edit_submissions'],
    can_manage_assignees: ['can_manage_assignees'],
    can_skip: ['can_skip'],
    can_rollback: ['can_rollback'],
    can_manage_integrations: ['can_manage_integrations'],
    can_administer: ['can_administer'],
  },
  request_grant: {
    can_view: ['can_view'],
    can_edit_metadata: ['can_edit_metadata'],
    can_manage_participants: ['can_manage_participants'],
    can_pause: ['can_pause'],
    can_reject: ['can_reject'],
    can_delete: ['can_delete'],
    can_edit_submissions: ['can_edit_submissions'],
    can_manage_documents: ['can_manage_documents'],
    can_view_documents: ['can_view_documents'],
    can_edit_documents: ['can_edit_documents'],
    can_manage_assignees: ['can_manage_assignees'],
    can_skip: ['can_skip'],
    can_rollback: ['can_rollback'],
    can_manage_integrations: ['can_manage_integrations'],
    can_manage_sourcing: ['can_manage_sourcing'],
    can_administer: ['can_administer'],
    can_view_tprm: ['can_view_tprm'],
    can_edit_tprm: ['can_edit_tprm'],
    can_manage_tprm: ['can_manage_tprm'],
  },
  agreement: {
    derived_owner: [
      'can_view',
      'can_edit',
      'can_cancel',
      'can_view_related_supplier',
      'can_view_related_requests',
      'can_manage_renewals',
      'can_view_documents',
      'can_manage_documents',
      'can_edit_documents',
      'can_administer',
    ],
    own_view: ['can_view'],
    conf_lineage_view: ['can_view'],
    can_view: ['can_view'],
    can_edit: ['can_edit'],
    can_cancel: ['can_cancel'],
    can_view_related_supplier: ['can_view_related_supplier'],
    can_view_related_requests: ['can_view_related_requests'],
    can_manage_renewals: ['can_manage_renewals'],
    can_view_documents: ['can_view_documents'],
    can_manage_documents: ['can_view_documents', 'can_manage_documents', 'can_edit_documents'],
    can_edit_documents: ['can_view_documents', 'can_edit_documents'],
    can_administer: ['can_administer'],
    can_delete: ['can_delete'],
  },
  renewal: {
    derived_assignee: ['can_view', 'can_manage'],
    linked_view: ['can_view'],
    unlinked_view: ['can_view'],
    can_view: ['can_view'],
    can_manage: ['can_manage'],
  },
  risk: {
    derived_owner: ['can_view'],
    can_view: ['can_view'],
    can_edit: ['can_edit'],
    can_delete: ['can_delete'],
  },
  agreement_grant: {
    can_view: ['can_view'],
    can_view_related_supplier: ['can_view_related_supplier'],
    can_view_related_requests: ['can_view_related_requests'],
    can_view_documents: ['can_view_documents'],
    can_edit: ['can_edit'],
    can_cancel: ['can_cancel'],
    can_manage_renewals: ['can_manage_renewals'],
    can_manage_documents: ['can_manage_documents'],
    can_edit_documents: ['can_edit_documents'],
    can_delete: ['can_delete'],
    can_administer: ['can_administer'],
  },
  document: {
    derived_uploader: ['can_edit', 'can_view'],
    derived_marker: ['can_manage', 'can_edit', 'can_view'],
    marked_viewer: ['can_view'],
    can_manage: ['can_manage', 'can_edit', 'can_view'],
    can_edit: ['can_edit', 'can_view'],
    can_view: ['can_view'],
  },
  document_grant: {
    can_view: ['can_view'],
    can_edit: ['can_edit'],
    can_manage: ['can_manage'],
  },
  tprm_grant: {
    can_view: ['can_view'],
    can_edit: ['can_edit'],
    can_manage: ['can_manage'],
  },
  bill: {
    derived_approver: ['can_approve', 'can_view'],
    derived_draft_assignee: ['can_edit_before_accept', 'can_accept', 'can_assign', 'can_view'],
    derived_mention: ['can_view'],
    can_edit_before_accept: ['can_edit_before_accept', 'can_view'],
    can_accept: ['can_accept', 'can_view'],
    can_assign: ['can_assign'],
    can_approve: ['can_approve'],
    can_view: ['can_view'],
  },
  bill_grant: {
    can_view: ['can_view'],
    can_edit_before_accept: ['can_edit_before_accept'],
    can_accept: ['can_accept'],
  },
  workflow: {
    can_create_request: ['can_create_request'],
  },
  workflow_grant: {
    can_create_request: ['can_create_request'],
  },
  insights_dashboard: {
    derived_owner: ['can_delete', 'can_edit', 'can_view', 'can_manage_org_access'],
    derived_viewer: ['can_view'],
    derived_editor: ['can_edit', 'can_view', 'can_manage_org_access'],
    viewer: ['can_view'],
    editor: ['can_edit', 'can_view', 'can_manage_org_access'],
    can_delete: ['can_delete'],
    can_edit: ['can_edit'],
    can_view: ['can_view'],
    can_manage_org_access: ['can_manage_org_access'],
  },
} as const

/** A writable relationship tuple — relation must be directly assignable on its object's type. */
export type FgaTuple = {
  [T in FgaObjectType]: { user: string; relation: FgaAssignableRelation<T>; object: FgaObjectRef<T> }
}[FgaObjectType]
